import { render, staticRenderFns } from "./best-comment.vue?vue&type=template&id=24f75480"
import script from "./best-comment.vue?vue&type=script&lang=ts"
export * from "./best-comment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports